import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_PURCHASE_API

/** ********公告模板******** */

// 自定义分页查询模板列表
export function getTemplateNoticeListApi(params) {
  return request({
    url: baseUrl + '/workbench/template-notice/page',
    method: 'get',
    params
  })
}

// 查询模板类型集合
export function getTemplateNoticeSortApi(params) {
  return request({
    url: baseUrl + '/workbench/template-notice/tree',
    method: 'get',
    params
  })
}

// 查询详情
export function getTemplateNoticeDetailApi(templateNoticeId) {
  return request({
    url: baseUrl + `/workbench/template-notice/detail/${templateNoticeId}`,
    method: 'get'
  })
}

// 新增公告模板
export function addNoticeTemplateApi(data) {
  return request({
    url: baseUrl + `/workbench/template-notice/add`,
    method: 'post',
    data
  })
}

// 修改公告模板
export function updateNoticeTemplateApi(data) {
  return request({
    url: baseUrl + `/workbench/template-notice/change`,
    method: 'put',
    data
  })
}

// 删除公告模板
export function deleteTemplateNoticeApi(templateNoticeId) {
  return request({
    url: baseUrl + `/workbench/template-notice/del/${templateNoticeId}`,
    method: 'delete'
  })
}

// 修改公告模板状态
export function changeTemplateNoticeStatusApi(data) {
  return request({
    url: baseUrl + `/workbench/template-notice/doEnabled`,
    method: 'patch',
    data
  })
}

// 根据模板编码查询变量值
export function getNoticeTemplateVariableApi(templateTypeId) {
  return request({
    url: baseUrl + `/workbench/template-notice/listTemplateVariable/${templateTypeId}`,
    method: 'get'
  })
}

// 获取招标编译后的模板
export function getBidCompileNoticeApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/bidding-orders/${orderId}/compile-notice`,
    method: 'post',
    data
  })
}

// 获取询比编译后的模板
export function getInquiryCompileNoticeApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/inquiry-orders/${orderId}/compile-notice`,
    method: 'post',
    data
  })
}

// 获取谈判采购编译后的模板
export function getNegotiationCompileNoticeApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/purchaser/negotiate-orders/${orderId}/compile-notice`,
    method: 'post',
    data
  })
}

// 获取分项谈判编译后的模板
export function getNegotiationV2CompileNoticeApi(data, orderId) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/${orderId}/compile-notice`,
    method: 'post',
    data
  })
}

// 获取分项谈判项目编译后的模板
export function getNegotiationV2BatchNoticeApi(data, orderIds, loading = false) {
  return request({
    url:
      baseUrl +
      `/workbench/v2/purchaser/hosp-negotiate-orders/compile-notice/batch?orderIds=${orderIds}`,
    method: 'post',
    data
  }, loading)
}

